import { render } from "./test.page.vue?vue&type=template&id=0bd8c6af"
import script from "./test.page.vue?vue&type=script&lang=js"
export * from "./test.page.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__